import React from 'react';
import PropTypes from 'prop-types';
import Pressable from "react-native-web/dist/exports/Pressable";
import Text from "react-native-web/dist/exports/Text";
import { selectSystemProps, resolvePressableTokens, htmlAttrs } from '../utils';
import { useListboxContext } from './ListboxContext';
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
const [selectProps, selectedSystemPropTypes] = selectSystemProps([htmlAttrs]);
const getItemStyles = _ref => {
  let {
    groupFontName,
    groupFontWeight,
    itemFontSize,
    itemPaddingTop,
    itemPaddingBottom,
    itemPaddingLeft,
    itemBorderLeftWidth,
    itemPaddingRight,
    itemBackgroundColor,
    itemColor,
    itemOutline,
    itemTextDecoration,
    itemBorderLeftColor,
    itemBorderRightWidth,
    itemBorderRightColor,
    itemBorderTopWidth,
    itemBorderTopColor,
    itemBorderBottomWidth,
    itemBorderBottomColor,
    itemBorderRadius
  } = _ref;
  return {
    fontFamily: `${groupFontName}${groupFontWeight}normal`,
    fontSize: itemFontSize,
    paddingTop: itemPaddingTop - itemBorderTopWidth,
    paddingBottom: itemPaddingBottom - itemBorderBottomWidth,
    paddingLeft: itemPaddingLeft - itemBorderLeftWidth,
    paddingRight: itemPaddingRight - itemBorderRightWidth,
    width: '100%',
    backgroundColor: itemBackgroundColor,
    color: itemColor,
    outline: itemOutline,
    textDecoration: itemTextDecoration,
    borderLeft: `${itemBorderLeftWidth}px solid ${itemBorderLeftColor}`,
    borderRight: `${itemBorderRightWidth}px solid ${itemBorderRightColor}`,
    borderTop: `${itemBorderTopWidth}px solid ${itemBorderTopColor}`,
    borderBottom: `${itemBorderBottomWidth}px solid ${itemBorderBottomColor}`,
    borderRadius: itemBorderRadius,
    justifyContent: 'center'
  };
};
const PressableItem = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  let {
    children,
    href,
    isChild = false,
    onBlur,
    onPress,
    tabIndex = 0,
    nextItemRef,
    prevItemRef,
    tokens,
    id,
    ...rest
  } = _ref2;
  const {
    selectedId,
    setSelectedId
  } = useListboxContext();
  const selectTextStyles = _ref3 => {
    let {
      groupFontName,
      groupFontWeight,
      itemFontSize,
      itemColor,
      lineHeight
    } = _ref3;
    return {
      fontFamily: `${groupFontName}${groupFontWeight}normal`,
      fontSize: itemFontSize,
      color: itemColor,
      lineHeight: lineHeight * itemFontSize
    };
  };
  const resolveButtonTokens = pressableState => {
    const themeTokens = resolvePressableTokens(tokens, pressableState, {
      isChild,
      current: id === selectedId && id !== undefined
    });
    return themeTokens;
  };
  const handleKeyPress = event => {
    if (['Enter', ' '].includes(event?.key)) {
      onPress?.(event);
    } else if (event?.key === 'ArrowDown') {
      nextItemRef.current.focus();
    } else if (event?.key === 'ArrowUp' && prevItemRef?.current) {
      prevItemRef.current.focus();
    }
  };
  return /*#__PURE__*/_jsx(Pressable, {
    isChild: isChild,
    style: pressableState => getItemStyles(resolveButtonTokens(pressableState)),
    onBlur: onBlur,
    onClick: onPress,
    onKeyPress: handleKeyPress,
    ref: ref,
    tabIndex: tabIndex,
    ...(href && {
      href
    }),
    ...(onPress && {
      onClick: onPress
    }),
    ...selectProps(rest),
    onPress: event => {
      setSelectedId(id);
      onPress(event);
    },
    children: pressableState => {
      return /*#__PURE__*/_jsxs(Text, {
        style: selectTextStyles(resolveButtonTokens(pressableState)),
        children: [children, " "]
      });
    }
  });
});
PressableItem.displayName = 'PressableItem';
PressableItem.propTypes = {
  ...selectedSystemPropTypes,
  href: PropTypes.string,
  isChild: PropTypes.bool,
  children: PropTypes.node.isRequired,
  onBlur: PropTypes.func,
  onPress: PropTypes.func,
  nextItemRef: PropTypes.object,
  prevItemRef: PropTypes.object
};
export default PressableItem;